import { useMemo } from "react";
import { usePreferences } from "./usePreferences";

export const useColumnsVisibilityPreferences = (feature: string) => {
    const rawConfig = usePreferences(feature);
    const config = Array.isArray(rawConfig) ? rawConfig : rawConfig?.columns;
    return useMemo(() => {
        return config
            ?.filter((column: any) => !column?.hideCompletely)
            ?.reduce((total: any, column: any) => {
                if (column?.hide) {
                    total[column.accessor] = false;
                }
                return total;
            }, {});
    }, [config]);
};
